

//LOCAL KEY VARIABLES

import { keyVariables } from "./core/configs/loadKeyVariables";

// export const REACT_APP_PORTAL_API_URL = "https://localhost:7212";

//DEMO KEY VARIABLES
// export const REACT_APP_PORTAL_API_URL = "http://api.portal.test.avangard.galex.md";
// export const REACT_APP_PUBLIC_API_URL = "http://api.public.test.avangard.galex.md";
// export const AUTH_API_URL = "http://auth.test.avangard.galex.md";
// export const REACT_APP_AUTH_API_URL = "http://auth.test.avangard.galex.md";
// export const REACT_APP_LOGIN_PAGE = "http://test.avangard.galex.md";

// export const REACT_APP_APPLICATION_ID = 7;
// export const REACT_APP_APPLICATION_ISPROD = false;
// export const AVANGARD_WEB_URL = "https://avangardmed.md";

//DEPLOY KEY VARIABLES
export const REACT_APP_PORTAL_API_URL = keyVariables.REACT_APP_PORTAL_API_URL;
export const REACT_APP_PUBLIC_API_URL = keyVariables.REACT_APP_PUBLIC_API_URL;
export const AUTH_API_URL = keyVariables.AUTH_API_URL;
export const REACT_APP_AUTH_API_URL = keyVariables.REACT_APP_AUTH_API_URL;
export const REACT_APP_LOGIN_PAGE = keyVariables.REACT_APP_LOGIN_PAGE;

export const REACT_APP_APPLICATION_ID = 7;
export const REACT_APP_APPLICATION_ISPROD = false;
export const AVANGARD_WEB_URL = "https://avangardmed.md";

//STAGING KEY VARIABLES

// export const REACT_APP_PORTAL_API_URL = "https://api.portal.uat2.avangardmed.md";
// export const REACT_APP_PUBLIC_API_URL = "https://api.public.uat1.avangardmed.md";

// export const AUTH_API_URL = "https://auth.uat2.avangardmed.md";
// export const REACT_APP_AUTH_API_URL = "https://auth.uat2.avangardmed.md";
// export const REACT_APP_LOGIN_PAGE = "https://avangard.uat2.avangardmed.md";
// export const REACT_APP_APPLICATION_ISPROD = false;
// export const REACT_APP_APPLICATION_ID = 7;

// export const AVANGARD_WEB_URL = "https://avangardmed.md";


//PROD KEY VARIABLES

// export const REACT_APP_PORTAL_API_URL = "https://api.portal.s2.avangardmed.md";
// export const REACT_APP_PUBLIC_API_URL = "https://api.public.avangardmed.md";

// export const AUTH_API_URL = "https://auth.s2.avangardmed.md";
// export const REACT_APP_AUTH_API_URL = "https://auth.s2.avangardmed.md";
// export const REACT_APP_LOGIN_PAGE = "https://avangard.s2.avangardmed.md";
// export const REACT_APP_APPLICATION_ISPROD = true;
// export const REACT_APP_APPLICATION_ID = 7;

// export const AVANGARD_WEB_URL = "https://avangardmed.md";
